export default __webpack_public_path__ + "static/media/integrated_session_icon.83ee0900.svg";